module.exports = __webpack_public_path__ + "img/11.48a9925a.png";